<script lang="ts">
  const size = 80;
  const strokeWidth = 10 / 3;
  const radius = (size - strokeWidth) / 2;
</script>

<div class="wrapper">
  <div
    class="container"
    style="--loading-spinner-size: {size}; --loading-spinner-radius: {radius};"
  >
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <g class="group">
        <circle class="background" cx={Number(size) / 2} cy={Number(size) / 2} r={radius} />
        <circle class="animation" cx={Number(size) / 2} cy={Number(size) / 2} r={radius} />
      </g>
    </svg>
  </div>
</div>

<style lang="scss">
  @use 'sass:math';
  @use '../styles/colors';

  $dashLength: 1.5;
  $strokeWidth: math.div(10, 3);
  $width: 80;
  $height: 80;

  $radius: math.div(($width - $strokeWidth), 2);
  $circumference: $radius * 2 * math.$pi;

  .wrapper {
    position: absolute;
    inset: 0;
    backdrop-filter: blur(1px);
  }

  .container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .group {
    fill: none;
  }

  .background {
    stroke: colors.$black10;
    stroke-width: var(--loading-spinner-stroke-width);
  }

  .animation {
    animation: rotation 2s linear infinite, circular-stroke 1.5s ease-in-out infinite;
    transform-origin: center center;
    stroke-linecap: round;
    stroke-width: var(--loading-spinner-stroke-width);
    stroke: colors.$black90;
  }

  @keyframes rotation {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes circular-stroke {
    0% {
      stroke-dasharray: $dashLength $circumference;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: math.div($circumference, $dashLength) $circumference;
      stroke-dashoffset: -(math.div(($circumference - $dashLength), ($dashLength * 2)));
    }

    100% {
      stroke-dasharray: math.div($circumference, $dashLength) $circumference;
      stroke-dashoffset: -($circumference - $dashLength);
    }
  }
</style>
